import React from 'react';
import ModalWrapper from '../ModalWrapper';
import { CommonFooter, DialogContent } from '../FormComponent';
import { DO_NOTHING } from '../../utils/commonfunctions';

const ConfirmationModal = ({
  open,
  onClose = DO_NOTHING,
  onConfirm = DO_NOTHING,
  title,
  message,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  loading = false,
}) => {
  const buttons = [
    {
      label: cancelButtonText,
      onClick: onClose,
      variant: 'outline',
      className: 'primary',
      disabled: loading,
    },
    {
      label: confirmButtonText,
      onClick: onConfirm,
      variant: 'primary',
      className: 'white bg-blue600',
      isdefault: true,
      loading,
    },
  ];


  return (
    <ModalWrapper
        isOpen={open}
        onClose={onClose}
        type="info"
        title={title}
        size="medium"
        footer={
          <CommonFooter
            buttons={buttons}
            align="right"
          />
        }
        border={false}
        children={<DialogContent children={message} />}
      />
  );

  // return (
    // <ModalWrapper
    //   open={open}
    //   onClose={onClose}
    //   title={renderTitle()}
    //   fields={fields}
    //   buttons={buttons}
    //   containerStyles={{
    //     width: "450px"
    //   }}
    // />
  // );
};

export default ConfirmationModal;